import React from 'react';
import {
  Container,
  Box,
  Paper,
  Typography,
  Button,
  IconButton,
  useTheme,
} from '@mui/material';
import { AiOutlineEdit } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../authContext';
import Header2 from '../components/Header2';

/**
 * Hier werden die Logindaten des Kunden verwaltet.
 */
const CustomerLogindataView = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [{ profile }] = useAuth();

  // return
  return (
    <Container maxWidth='xs'>
      <Box mt={3}>
        <Header2
          title='Logindaten'
          subtitle='Hier haben Sie die Möglichkeit Ihre Logindaten zu ändern.'
        />
      </Box>
      <Box mt={2}>
        <Paper elevation={0} sx={{ p: 1.5 }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <Typography
              variant='caption'
              sx={{ fontWeight: theme.typography.fontWeightMedium }}
            >
              E-Mail:
            </Typography>
            <IconButton
              color='inherit'
              size='small'
              onClick={() => navigate('/customerEmail')}
            >
              <AiOutlineEdit size='22' />
            </IconButton>
          </Box>
          <Box>
            <Typography variant='body1'>{profile.email}</Typography>
          </Box>
        </Paper>
        <Paper elevation={0} sx={{ p: 1.5, mt: 0.5 }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <Typography
              variant='caption'
              sx={{ fontWeight: theme.typography.fontWeightMedium }}
            >
              Passwort:
            </Typography>
            <IconButton
              color='inherit'
              size='small'
              onClick={() => navigate('/customerPassword')}
            >
              <AiOutlineEdit size='22' />
            </IconButton>
          </Box>
          <Box>
            <Typography variant='body1'>******</Typography>
          </Box>
        </Paper>
      </Box>
      <Box
        mt={3}
        mb={4}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Button
          sx={{
            borderRadius: 30,
            width: '240px',
          }}
          type='submit'
          variant='contained'
          color='secondary'
          onClick={() => navigate('/customer')}
        >
          Ok
        </Button>
      </Box>
    </Container>
  );
};

export default CustomerLogindataView;
